const scrollToHash = (hash, offset = 0) => {
  if (!hash || hash === '#') {
    return;
  }

  let element;
  try {
    element = document.querySelector(hash);
  } catch (e) {
    return;
  }
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};

window.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (hash) {
    setTimeout(() => {
      const stickyFilter = document.querySelector('.fund-listing-sticky-filter');
      const isDesktop = window.matchMedia('(min-width: 992px)').matches;
      const offset = isDesktop && stickyFilter ? stickyFilter.getBoundingClientRect().height : 120;
      scrollToHash(hash, offset);
    }, 50);
  }

  const links = document.querySelectorAll('a[href^="#"]');
  if (links.length > 0) {
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const hash = link.getAttribute('href');
        const offset = parseInt(link.dataset.scrollOffset, 10) || 120;
        scrollToHash(hash, offset);
        window.history.pushState({}, '', hash);
      });
    });
  }
});
